import React from 'react';

import l10n from "../../l10n/localization";
import Date from "./tableComponents/Date";
import Commodities from "./tableComponents/Commodities";
import DischargeCountries from "./tableComponents/DischargeCountries";
import LoadCountries from "./tableComponents/LoadCountries";
import Tonnage from "./tableComponents/Tonnage";
import {Button, Icon, NavItem} from "react-materialize";
import FogTabs from "./FogTabs";
import sematable, {Table} from "sematable";
import * as creationActions from "../../actions/creation";
import * as fogActions from "../../actions/fog";
import Dropdown from "../common/Dropdown";

export const FOGS_TABLE = 'FOGS_TABLE';

const columns = [
    { key: 'archived', header: l10n.fog.archived, filterable: true},
    { key: 'creation_date', header: l10n.fog.creationDate, sortable: true, Component: Date},
    { key: 'file_nb', header: l10n.fog.fileNb, primaryKey: true, sortable: true, searchable: true, filterable: true},
    { key: 'client', header: l10n.fog.client, sortable: true, searchable: true, filterable: true},
    { key: 'vessel', header: l10n.fog.vessel, sortable: true, searchable: true, filterable: true},
    { key: 'cover_type', header: l10n.fog.coverType },
    { key: 'underwriter', header: l10n.fog.underwriter, sortable: true, searchable: true, filterable: true},
    { key: 'commodities', header: l10n.fog.commodities, Component: Commodities, searchable: true},
    { key: 'year', header: l10n.fog.year, sortable: true, filterable: true},
    { key: 'load_country', header: l10n.fog.loadCountry, Component: LoadCountries, searchable: true},
    { key: 'discharge_country', header: l10n.fog.dischargeCountry, Component: DischargeCountries, searchable: true},
    { key: 'total_tonnes', header: l10n.fog.metricTonnes, sortable: true, Component: Tonnage},
    { key: 'affiliate_invoices', header: l10n.fog.affiliate_invoices, searchable: true, filterable: true, hidden: true},
    { key: 'actions', header: '' }
];

class FogTable extends React.Component {

    addActions() {
        this.props.columns[this.props.columns.length - 1].Component = ({row}) => {
            return (
                <div className="fog-table-buttons">
                    <Button floating onClick={() => this.props.handleClick(FogTabs, row.original, creationActions.destroyingnewlyCreatedFog())} icon="edit" className="edit-button" />
                    {<Dropdown trigger={(props) => (
                        <Button floating icon="more_vert" className="more-button" onClick={props.onClick}/>)}>
                        <NavItem>
                            <Button disabled={this.props.duplicating} className="transparent" onClick={() => this.props.dispatch(fogActions.duplicateFog(row.original.id))} >
                                {l10n.common.duplicate}
                            </Button>
                        </NavItem>
                    </Dropdown>}
                </div>
            )
        };

        this.props.columns[0].Component = ({row}) => {
            return (
                <div>
                    {row.original.archived && <Icon className="center">lock</Icon>}
                </div>
            )
        };

        if (this.props.displayAll) {
            this.props.columns[0].header = l10n.fog.archived;
        }
    }

    render() {
        this.addActions();

        return (
            <Table
                {...this.props}
            />
        )
    }
}

export default sematable(FOGS_TABLE, FogTable, columns, {
    defaultPageSize: -1,
    autoHidePagination: true,
    showPageSize: false
});



// WEBPACK FOOTER //
// ./src/components/fog/FogTable.js